(function() {
  const header = document.querySelector('.header');
  const heroModules = document.querySelector('.heroModules');
  const headerSection = document.querySelector('.headerSection');

  headerSection.style.marginTop = `${document.querySelector('.noticeList').scrollHeight}px`;

  function toggleHeaderModule() {
    if (window.pageYOffset < 1) {
      if (document.querySelector('.heroModules__wrapper--split')) {
        header.classList.add('header--split');
      } else if (document.querySelector('.heroModules__wrapper--display')) {
        header.classList.add('header--display');
      } else if (document.querySelector('.heroModules__wrapper--full')) {
        header.classList.add('header-full');
      }
    } else {
      if (document.querySelector('.heroModules__wrapper--split')) {
        header.classList.remove('header--split');
      } else if (document.querySelector('.heroModules__wrapper--display')) {
        header.classList.remove('header--display');
      } else if (document.querySelector('.heroModules__wrapper--full')) {
        header.classList.remove('header-full');
      }
    }
  }

  toggleHeaderModule();

  window.addEventListener('scroll', toggleHeaderModule);
}());
